import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const links = [
  { id: "about", label: "About", testid: LANDING.navAbout },
  { id: "services", label: "Services", testid: LANDING.navServices },
  { id: "gallery", label: "Gallery", testid: LANDING.navGallery },
  { id: "faq", label: "FAQ", testid: "nav-faq-link" },
  { id: "contact", label: "Contact", testid: LANDING.navContact },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F4F1EA]/85 backdrop-blur-xl backdrop-saturate-150 border-b border-[#1A2B3C]/10"
          : "bg-[#F4F1EA]/60 backdrop-blur-md"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <button
          data-testid={LANDING.navLogo}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex flex-col items-start leading-none text-left"
        >
          <span className="font-display text-2xl md:text-[26px] tracking-tight text-[#1A2B3C]">
            Kristy Worrell
          </span>
          <span className="font-mono-editorial text-[10px] mt-1 text-[#C05A44]">
            BAHAMAS · PERSONAL CHEF
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollTo(l.id)}
              className="nav-link font-body text-sm tracking-wide text-[#1A2B3C]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid={LANDING.navBookCta}
            onClick={() => scrollTo("contact")}
            className="btn-primary font-body text-xs tracking-[0.2em] uppercase px-6 py-3 border border-[#1A2B3C] text-[#1A2B3C] hover:bg-[#1A2B3C] hover:text-[#F4F1EA]"
          >
            Book Chef
          </button>
        </nav>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#1A2B3C]"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-[#F4F1EA] border-t border-[#1A2B3C]/10">
          <nav className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-${l.testid}`}
                onClick={() => scrollTo(l.id)}
                className="font-body text-left text-[#1A2B3C] text-lg"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-nav-book-cta"
              onClick={() => scrollTo("contact")}
              className="mt-2 font-body text-xs tracking-[0.2em] uppercase px-6 py-3 border border-[#1A2B3C] text-[#1A2B3C]"
            >
              Book Chef
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
